import { SupportedFileWithMetadata } from 'APP/Converse/FilePreview/types'
import { QueueFileInput, isDuplicateSelection } from 'APP/Lib/FileUploadHelpers'

export type FileSelectionResult = 'replaced' | 'queued' | 'duplicate'

export type FileSelectionParams<IncomingFile> = {
  files: SupportedFileWithMetadata[]
  incomingFile: IncomingFile
  comparableIncomingFile: QueueFileInput
  replacingIndex: number | null
  queueFile: (file: IncomingFile) => boolean
  replaceFile: (file: IncomingFile, index: number) => boolean
  removeFile: (file: SupportedFileWithMetadata, index: number) => void
  duplicateErrorMessage: string
  setDuplicateFileError: (message: string | null) => void
  clearSelectedFile: () => void
}

export const handleIntakeFileSelection = <IncomingFile>(
  params: FileSelectionParams<IncomingFile>
): FileSelectionResult => {
  const {
    files,
    incomingFile,
    comparableIncomingFile,
    replacingIndex,
    queueFile,
    replaceFile,
    removeFile,
    duplicateErrorMessage,
    setDuplicateFileError,
    clearSelectedFile,
  } = params

  const finish = (result: FileSelectionResult) => {
    clearSelectedFile()
    return result
  }

  if (typeof replacingIndex === 'number') {
    const replacingFile = files[replacingIndex]
    const filesExcludingReplacingIndex = files.filter((_, index) => index !== replacingIndex)

    if (isDuplicateSelection(filesExcludingReplacingIndex, comparableIncomingFile)) {
      if (replacingFile) {
        removeFile(replacingFile, replacingIndex)
      }
      setDuplicateFileError(duplicateErrorMessage)
      return finish('duplicate')
    }

    const didReplace = replaceFile(incomingFile, replacingIndex)
    if (didReplace) {
      setDuplicateFileError(null)
    }
    return finish('replaced')
  }

  if (isDuplicateSelection(files, comparableIncomingFile)) {
    setDuplicateFileError(duplicateErrorMessage)
    return finish('duplicate')
  }

  const didQueue = queueFile(incomingFile)
  if (didQueue) {
    setDuplicateFileError(null)
  } else if (isDuplicateSelection(files, comparableIncomingFile)) {
    setDuplicateFileError(duplicateErrorMessage)
  }

  return finish('queued')
}
